/**
 *  RadioGroup script file
**/

export default {
  name: 'RadioGroup',
  mixins: [],
  components: {
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      default: 'radios'
    },
    value: {
      type: [String, Boolean, Number],
      required: true
    },
    vertical: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    getClasses () {
      return {
        vertical: this.vertical,
        disabled: this.disabled
      }
    }
  },
  methods: {}
}
